import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id D390D1E2-571E-49DB-BBB9-9D3821EAF819
 * name plex
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plex.svg
 * tags
 * - Brand / Logo 
 */
export const PlexIcon = createSvgIcon(<><path d="M4,2C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2H4M8.56,6H12.06L15.5,12L12.06,18H8.56L12,12L8.56,6Z" /></>, 'PlexIcon');
export default PlexIcon